module.exports = __webpack_public_path__ + "static/media/test13_3.ad33e3b0.png";